import { render, staticRenderFns } from "./IconSvgSvg.vue?vue&type=template&id=f1fc0706&scoped=true&"
import script from "./IconSvgSvg.vue?vue&type=script&lang=js&"
export * from "./IconSvgSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fc0706",
  null
  
)

export default component.exports